import { EntryState } from '@enums/strapiTypesAndOperators'

export const baseURL = `${process.env.ACKO_CMS_URL}/api`
export const headers = {
  Authorization: `Bearer ${process.env.AUTHORIZATION_TOKEN}`,
}
export const PublicationStatusBasedOnEnv = process.env.ACKO_ENV === 'prod' ? EntryState.Live : EntryState.Preview
